import api from '../utils/api';

export async function listContactsByAgent(agentId, { page = 1, perPage = 20, search = null } = {}) {
  const params = { page, per_page: perPage };
  if (search) {
    params.search = search;
  }
  const { data } = await api.get(`/agents/${agentId}/contacts`, { params });
  return data;
}

export async function getContact(contactId) {
  const { data } = await api.get(`/contacts/${contactId}`);
  return data;
}

export async function updateContactContext(contactId, progressiveSummary) {
  const { data } = await api.patch(`/contacts/${contactId}/context`, {
    progressive_summary: progressiveSummary,
  });
  return data;
}

export async function updateContactOnboarding(
  contactId,
  { onboardingData, onboardingCompleted } = {}
) {
  const body = {};
  if (onboardingData !== undefined) {
    body.onboarding_data = onboardingData;
  }
  if (onboardingCompleted !== undefined) {
    body.onboarding_completed = onboardingCompleted;
  }
  const { data } = await api.patch(`/contacts/${contactId}/onboarding`, body);
  return data;
}

export async function listContactMessages(contactId, { page = 1, perPage = 50, sessionId = null } = {}) {
  const params = { page, per_page: perPage };
  if (sessionId) {
    params.session_id = sessionId;
  }
  const { data } = await api.get(`/contacts/${contactId}/messages`, {
    params,
  });
  return data;
}

export async function getContactMetaMessaging(contactId) {
  const { data } = await api.get(`/contacts/${contactId}/meta-messaging`);
  return data;
}

export async function listContactMetaTemplates(contactId, channelId) {
  const { data } = await api.get(`/contacts/${contactId}/meta-messaging/templates`, {
    params: { channel_id: channelId },
  });
  return data;
}

export async function sendContactMetaMessage(contactId, payload) {
  const { data } = await api.post(`/contacts/${contactId}/meta-messaging`, payload);
  return data;
}

export async function resetContact(contactId) {
  const { data } = await api.post(`/contacts/${contactId}/reset`);
  return data;
}

export async function releaseContactHandoff(contactId) {
  const { data } = await api.post(`/contacts/${contactId}/release-handoff`);
  return data;
}
